import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from "@mui/material/Tooltip";
import Chip from "studio/components/Chip/Chip";
import SecurityIcon from "@mui/icons-material/Security";
const RoleChip = ({ className, roleId, role, tooltipPlacement, ...props }) => {
    return (_jsx(Tooltip, { title: _jsx("div", { children: role?.description || "" }), placement: tooltipPlacement || "top", arrow: true, children: _jsx(Chip, { className: className, icon: _jsx(SecurityIcon, {}), label: role?.name || roleId, ...props }) }));
};
export default RoleChip;
